import _styled from "@emotion/styled-base";
import React from 'react';
import { AuthorBio } from '../AuthorBio';

var Title = _styled("h1", {
  target: "e6p6y3e0",
  label: "Title"
})(function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.bold;
}, ";border-bottom:1rem solid ", function (_ref2) {
  var theme = _ref2.theme;
  return theme.contentHeader.authorBylineBorder;
}, ";color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.gray[700];
}, ";font-size:32px;margin:0 auto;padding-bottom:1rem;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Db250ZW50SGVhZGVyL2luZGV4LmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLdUIiLCJmaWxlIjoiLi4vLi4vc3JjL0NvbnRlbnRIZWFkZXIvaW5kZXguanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBvYmplY3QsIHN0cmluZyB9IGZyb20gJ3Byb3AtdHlwZXMnXG5pbXBvcnQgeyBBdXRob3JCaW8gfSBmcm9tICcuLi9BdXRob3JCaW8nXG5cbmNvbnN0IFRpdGxlID0gc3R5bGVkLmgxYFxuXHQkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmZvbnRzLmJvbGR9O1xuXHRib3JkZXItYm90dG9tOiAxcmVtIHNvbGlkICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29udGVudEhlYWRlci5hdXRob3JCeWxpbmVCb3JkZXJ9O1xuXHRjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb2xvcnMuZ3JheVs3MDBdfTtcblx0Zm9udC1zaXplOiAzMnB4O1xuXHRtYXJnaW46IDAgYXV0bztcblx0cGFkZGluZy1ib3R0b206IDFyZW07XG5gXG5cbkNvbnRlbnRIZWFkZXIucHJvcFR5cGVzID0ge1xuXHRhdXRob3I6IG9iamVjdC5pc1JlcXVpcmVkLFxuXHRieUxpbmU6IHN0cmluZyxcblx0bGFzdE1vZGlmaWVkOiBzdHJpbmcuaXNSZXF1aXJlZCxcblx0cHVibGlzaGVkOiBzdHJpbmcuaXNSZXF1aXJlZCxcblx0c3BvbnNvcnNoaXA6IG9iamVjdCxcblx0dGl0bGU6IHN0cmluZy5pc1JlcXVpcmVkLFxufVxuXG5leHBvcnQgZnVuY3Rpb24gQ29udGVudEhlYWRlcih7IGF1dGhvciwgYnlMaW5lLCBsYXN0TW9kaWZpZWQsIHB1Ymxpc2hlZCwgc3BvbnNvcnNoaXAsIHRpdGxlIH0pIHtcblx0cmV0dXJuIChcblx0XHQ8PlxuXHRcdFx0PFRpdGxlPnt0aXRsZX08L1RpdGxlPlxuXHRcdFx0PEF1dGhvckJpb1xuXHRcdFx0XHRhdXRob3I9e2F1dGhvcn1cblx0XHRcdFx0YnlMaW5lPXtieUxpbmV9XG5cdFx0XHRcdGxhc3RNb2RpZmllZD17bGFzdE1vZGlmaWVkfVxuXHRcdFx0XHRwdWJsaXNoZWQ9e3B1Ymxpc2hlZH1cblx0XHRcdFx0c3BvbnNvcnNoaXA9e3Nwb25zb3JzaGlwfVxuXHRcdFx0Lz5cblx0XHQ8Lz5cblx0KVxufVxuIl19 */"));

export function ContentHeader(_ref4) {
  var author = _ref4.author,
      byLine = _ref4.byLine,
      lastModified = _ref4.lastModified,
      published = _ref4.published,
      sponsorship = _ref4.sponsorship,
      title = _ref4.title;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, null, title), /*#__PURE__*/React.createElement(AuthorBio, {
    author: author,
    byLine: byLine,
    lastModified: lastModified,
    published: published,
    sponsorship: sponsorship
  }));
}